const breadcrumbsMixin = {
  computed: {
    breadcrumbs() {
      let breadcrumbs = [];
      breadcrumbs = this.getParentBreadcrumbs(this.$route, breadcrumbs);
      breadcrumbs.push({
        text: this.$route.meta.title,
        disabled: true,
        href: this.$route.path,
      });
      return breadcrumbs;
    },
    showBreadcrumbs() {
      if (this.$route.meta && this.$route.meta.breadcrumbs) {
        const breadcrumb = this.$route.meta.breadcrumbs;
        if (Object.prototype.hasOwnProperty.call(breadcrumb, 'show')) return breadcrumb.show;
      }
      return true;
    },
  },
  methods: {
    getParentBreadcrumbs(route, crumbs) {
      let breadcrumbs = [];
      breadcrumbs.push(...crumbs);
      if (route.meta && route.meta.breadcrumbs && route.meta.breadcrumbs.parent) {
        const parent = this.$router.resolve({ name: route.meta.breadcrumbs.parent });
        breadcrumbs.unshift({
          text: parent.route.meta.title,
          disabled: false,
          exact: true,
          to: parent.route.path,
        });
        breadcrumbs = this.getParentBreadcrumbs(parent.route, breadcrumbs);
      }
      return breadcrumbs;
    },
  },
};

export default breadcrumbsMixin;
